import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import Supply from "./Supply";

export default class Supplies extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'supply',
            data: null,
            loading: true,
            filters: {
                filter: 0,
                type: props.Type,
            },
            systemModuleId: 38,
            moduleAccessStatus: 1,
            page: 1,
            per_page: 30,
            phrase: '',
            sort: '',
            menuId: 0
        };
        this.setMenuId(this.state.filters.type);

        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    setMenuId(type) {
        if (type === 1) this.state.menuId = 190;
        if (type === 2) this.state.menuId = 191;
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;

                this.refreshData();
            });
    }
    componentWillReceiveProps(props) {
        if (props.Type == this.state.filters.type) return;
        this.state.filters.type = props.Type;
        this.setMenuId(this.state.filters.type);
        this.refreshData();
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Supply Type={this.state.filters.type} Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <Supply Type={this.state.filters.type} Caller={this} /> });
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return [
            <div className="dashboard-header">
                {this.state.filters.type === 1 && <h1 className="dashboard-title">درخواستهای کالا</h1>}
                {this.state.filters.type === 2 && <h1 className="dashboard-title">سفارشات خرید</h1>}
            </div>,
            <div className="mb-4">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-body p-3 row">
                            <div className="row align-content-center p-0">
                                <div className="newBtnHolder" >
                                    <a onClick={e => this.onAdd()} className="align-items-center btn btn-outline-success d-flex justify-center mt-2 w-100">
                                        <i className="mir-add-pluse fs-6"></i>
                                        <span className="me-1">افزودن</span>
                                    </a>
                                </div>
                                <div className="vertical-line me-3">
                                </div>
                                <div className="col align-content-center">
                                    <div className="d-flex text-center align-items-center fs-9 fw-medium gap-4" className="filterIconHolder">
                                        <img src="/assets/images/icons/filter-sort.svg" alt="" />
                                        <label>فیلتر براساس</label>
                                    </div>
                                    <form className="d-flex p-0 gap-16 filterFields" onSubmit={e => this.refreshData(e)}>

                                        <div className="form-group m-0 col">
                                            <input defaultValue={this.state.phrase} onChange={e => this.state.phrase = e.target.value} type="text" className="form-input" placeholder="درخواست دهنده" />
                                        </div>
                                        <div>
                                            <button onClick={e => this.refreshData(e)} type="submit" className="w-100 btn btn-blue align-items-center" style={{ "padding": "12px 12px 8px 12px" }} >
                                                <i className="mir-search fs-6"></i>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>,
            <div className="invoices-table-container">
                {this.state.data.recordsCount <= 0 ?
                    <div className="alert-text">
                        <h6>توجه</h6>
                        <p>نتیجه ای یافت نشد</p>
                    </div>
                    :
                    <table className="invoices-table persons-table">
                        <thead>
                            <tr>
                                <th>شماره</th>
                                <th>درخواست کننده</th>
                                <th>تاریخ</th>
                                <th>وضعیت</th>
                                <th>وضعیت</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.data.records.map((record, index) =>
                                <tr>
                                    <td>
                                        <span>
                                            <a className="text-primary txt-bold hand" onClick={e => this.onEdit(record.id)} title="مشاهده و ویرایش">
                                                {record.number}
                                            </a>
                                        </span>
                                    </td>
                                    <td>
                                        <span>{record.requestedPersonName}</span>
                                    </td>
                                    <td>
                                        <span>{record.dateString}</span>
                                    </td>
                                    <td>
                                        <span>{record.statusString}</span>
                                    </td>
                                    <td>
                                        <div className="item-actions">
                                            <a className="item-delete-btn" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف">
                                                <i className="mir-trash text-danger"></i>
                                            </a>
                                            <a className="item-edit-btn" onClick={e => this.onEdit(record.id)} title="ویرایش">
                                                <i className="mir-pen-edit text-blue-ff"></i>
                                            </a>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                }
                <div className="mobile-table">
                    {this.state.data.records.map((record, index) =>
                        <div className="card p-3 row mt-2 flex justify-content-between">
                            <div>
                                <span>
                                    <b>شماره: </b>
                                    <a className="text-primary txt-bold hand" onClick={e => this.onEdit(record.id)} title="مشاهده و ویرایش">
                                        {record.number}
                                    </a>
                                </span>
                            </div>
                            <div>
                                <b>درخواست کننده: </b>
                                <span>{record.requestedPersonName}</span>
                            </div>
                            <div>
                                <b>تاریخ: </b>
                                <span>{record.dateString}</span>
                            </div>
                            <div>
                                <b>وضعیت: </b>
                                <span>{record.statusString}</span>
                            </div>
                            <div>
                                <div className="item-actions">
                                    <a className="item-delete-btn" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف">
                                        <i className="mir-trash text-danger"></i>
                                    </a>
                                    <a className="item-edit-btn" onClick={e => this.onEdit(record.id)} title="ویرایش">
                                        <i className="mir-pen-edit text-blue-ff"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                {this.createPaging()}
            </div>
        ]
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm(),
                this.renderPopupComponent(),
            ];
        return contents;
    }
}